import { render, staticRenderFns } from "./RELManutencao.vue?vue&type=template&id=806738e8&"
import script from "./RELManutencao.vue?vue&type=script&lang=js&"
export * from "./RELManutencao.vue?vue&type=script&lang=js&"
import style0 from "./RELManutencao.vue?vue&type=style&index=0&id=806738e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports